/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Hubspot_Company_Not_ConfirmableInputs */

const en_error_hubspot_company_not_confirmable = /** @type {(inputs: Error_Hubspot_Company_Not_ConfirmableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The company of HubSpot no longer waits for this choice. The list shows what it is now.`)
};

/**
* | output |
* | --- |
* | "The company of HubSpot no longer waits for this choice. The list shows what it is now." |
*
* @param {Error_Hubspot_Company_Not_ConfirmableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_hubspot_company_not_confirmable = /** @type {((inputs?: Error_Hubspot_Company_Not_ConfirmableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Hubspot_Company_Not_ConfirmableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_hubspot_company_not_confirmable(inputs)
});